import { forOwn, isArray, isObject } from 'lodash';
import axios from 'axios';

export const DetectHTMLTagsPattern = /<[^>]*>?/gm;
/**
 * detect if an item has a sibling element to either side
 * accepts an existing array with at least 1 member
 *
 *  @example
 * const array = [0,1,2];   // 3 items
 * withSibling(array, 0) // true
 * withSibling(array, 1) // true
 * withSibling(array, 2) // false
 *
 * @param {Array} array source array
 * @param {number} index index of item
 * @returns {boolean} true if element at `index` has a sibling
 */
export function withSibling(array = [], index = 0) {
  // even array always have a sibling
  if (array.length % 2 === 0) {
    return true;
  }

  // last element of an odd number elements in array
  return index !== array.length - 1;
}

export function mapper(mapFn) {
  return function(combine) {
    return (result, x) => combine(result, mapFn(x));
  };
}

export function filterer(f) {
  return function(combine) {
    return function(result, x) {
      return f(x) ? combine(result, x) : result;
    };
  };
}

export function append(result, x) {
  result.push(x);
  return result;
}

export function transduce(xForm, fn, init, coll) {
  return coll.reduce(xForm(fn), init);
}

export function compose(...funcs) {
  if (funcs.length === 0) {
    // infer the argument type so it is usable in inference down the line
    return id => id;
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

/**
 *
 * @param {object} dispatcher an object with a dispatch method
 * @param {object|Map|Array} dispatchMap key|value pairing of dispatch type and value
 * @example
 * groupDispatch(store, {'findId': 55}) // store.dispatch('findId', 55)
 * groupDispatch(store, new Map[['findId', 55]]) // store.dispatch('findId', 55)
 * groupDispatch(store, [{key: 'findId', value: 55}]) // store.dispatch('findId', 55)
 */
export function groupDispatch(dispatcher, dispatchMap) {
  if (dispatchMap instanceof Map) {
    for (const [key, val] of dispatchMap) dispatcher.dispatch(key, val);
  } else if (isArray(dispatchMap)) {
    dispatchMap.forEach(item => dispatcher.dispatch(item.key, item.value));
  } else {
    forOwn(dispatchMap, (val, key) => dispatcher.dispatch(key, val));
  }
}

/**
 * Recursively iterate object properties.
 * @param {object} obj object to iterate
 * @param {object} options options
 * @param {function} options.fn function to run on value
 */
export function objectWalker(obj, options = {}) {
  for (const key of Object.keys(obj)) {
    const value = obj[key];

    if (isObject(value)) {
      objectWalker(value, options);
    } else {
      options.fn(value, key, obj, options);
    }
  }
}

export async function logSSAEventToAPI(event, eventName) {
  try {
    const cookieName = 'drushim_OfferSearchABTest';
    let json = JSON.stringify(event, null, 2);
    const obj = {
      log: json,
      eventName: eventName
    };
    axios.post('/api/admin/logdebug', obj, { withCredentials: true });

    if (!getCookie(cookieName)) {
      const cookieExpiration = new Date(event.CookieExperation * 1000);

      setCookie(cookieName, event.ABTestCookie, cookieExpiration);
    }
  } catch (err) {
    console.log(err);
  }
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
}

function setCookie(name, value, date) {
  var expires = '';
  expires = '; expires=' + date.toUTCString();

  if (window.location.protocol === 'https:') {
    expires += ';SameSite=None;secure';
  }

  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
